import React, { FC, MouseEventHandler, useState } from 'react';
import { Icon } from '../icons/icons';
import './IconHoverButton.scss';


interface IconHoverButtonProps {
   isLink: boolean,
   linkURL: string | null,
   buttonClassName: string,
   buttonClassHoverName: string,
   buttonOnClick: MouseEventHandler | null,
   iconClassName: string,
   iconHoverClassName: string,
   iconName: string,
   iconHoverName: string,
   buttonText?: string | null,
   buttonTextClassName?: string | null,
   buttonTextHoverClassName?: string | null
}

const IconHoverButton: React.FC<IconHoverButtonProps> = ({
   isLink,
   linkURL,
   buttonClassName,
   buttonClassHoverName,
   buttonOnClick,
   iconClassName,
   iconHoverClassName,
   iconName,
   iconHoverName,
   buttonText = null,
   buttonTextClassName = null,
   buttonTextHoverClassName = null
}) => {
   const [isHovered, setIsHovered] = useState(false);
   const haveButtonText = buttonText !== null;
   const noHoverTransition = iconClassName === iconHoverClassName;

   //button classes
   const buttonClasses = [buttonClassName];
   if (!haveButtonText) buttonClasses.push('icon-hover-button');
   if (haveButtonText) buttonClasses.push('icon-text-hover-button');
   if (isHovered) buttonClasses.push(buttonClassHoverName);

   //non-hover icons classes
   const iconClasses = ['icon', iconClassName];
   if (isHovered) iconClasses.push('hovered');

   //hover icon classes
   const hoverIconClasses = ['icon-hover', iconHoverClassName];
   if (isHovered) hoverIconClasses.push('hovered');

   //button text classes
   const buttonTextClasses = [buttonTextClassName];
   if (isHovered) buttonTextClasses.push(buttonTextHoverClassName);



   return (
      <>
         {!isLink && buttonOnClick !== null && (
            <button
               onClick={buttonOnClick}
               onMouseOver={() => setIsHovered(true)}
               onMouseOut={() => setIsHovered(false)}
               className={buttonClasses.join(' ')}>
               <Icon name={iconHoverName} className={hoverIconClasses.join(' ')} />
               <Icon name={iconName} className={iconClasses.join(' ')} />
               {haveButtonText ? <span className={buttonTextClasses.join(' ')}>{buttonText}</span> : null}
            </button>
         )}

         {isLink && linkURL !== null && (
            <a
               href={linkURL}
               onMouseOver={() => setIsHovered(true)}
               onMouseOut={() => setIsHovered(false)}
               className={buttonClasses.join(' ')}>
               <Icon name={iconHoverName} className={hoverIconClasses.join(' ')} />
               <Icon name={iconName} className={iconClasses.join(' ')} />
               {haveButtonText ? <span className={buttonTextClasses.join(' ')}>{buttonText}</span> : null}
            </a>
         )}
      </>
   )
};

export default IconHoverButton;
